import script from "./overview.vue?vue&type=script&setup=true&lang=ts"
export * from "./overview.vue?vue&type=script&setup=true&lang=ts"

import "./overview.vue?vue&type=style&index=0&id=1f001047&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f001047"]])

export default __exports__